import operations from '~/helpers/device-operations';
import { boilerControl, dhwControl, fwPrivate } from '~/helpers/fields-description';
import { BehaviorKey } from '~/interfaces/device.interface';
import { Gateway } from '~/models/gateways/gateway.model';
import { getServerNodeFields } from '~/models/helpers/network.function';

export class OTH extends Gateway {
    MAX_TIME_BEFORE_UNKNOWN = 6 * 3600;
    behaviorFields: BehaviorKey[] = [
        'relay_polarity_inverted',
        'rf_statistics_enabled',
    ];

    loadData(data: any) {
        super.loadData(data);
        this.loadHeatingAlgo(data.heating_algo);
    }

    get fieldBoilerControl() {
        return boilerControl(this.boiler_control);
    }
    get fieldDhwControl() {
        return dhwControl(this.dhw_control);
    }
    get fieldFwPrivate() {
        return fwPrivate(this.firmware_private);
    }

    get deviceOperations() {
        return super.deviceOperations.concat([
            operations.dump({ callback: this.dump }),
            operations.dumpLogs({ callback: this.dumpLogs }),
            operations.logs({ callback: this.logs }),
            operations.orderReboot({ callback: this.orderReboot, disabled: this.isOrderRebootDisabled }),
            operations.setDump({ callback: this.setDump }),
            operations.deleteCache({ callback: this.deleteCache }),
        ]);
    }

    getNetworkFields() {
        let fields = super.getNetworkFields();
        if (this.network) {
            fields = fields.concat(getServerNodeFields(this.network.server_node));
        }
        return fields;
    }

}
